import { KNOT_TO_KMH, SPEED_SCALE, UNKNOWN_DIRECTION } from "./utils";

const traccarPoint = L.LayerGroup.extend({
    _device: {},
    _marker: null,
    _vector: null,

    initialize: function (device) {
        this._device = device;
        this._createLayers();
    },

    _createLayers: function() {
        this._device.lastPosition.deviceTime = new Date(this._device.lastPosition.deviceTime).toLocaleString();
        this._marker = L.traccarMarker([
            this._device.lastPosition.latitude,
            this._device.lastPosition.longitude
        ], this._device);

        L.LayerGroup.prototype.initialize.call(
            this, [this._marker].filter(layer => layer)
        );

        this._computeMotion();
    },

    _computeMotion: function () {
        const position = this._device.lastPosition;

        if (!position || position.course === null || position.course === UNKNOWN_DIRECTION) {
            return;
        }

        // Retirer l'ancien vecteur s'il existe
        if (this._vector && this.hasLayer(this._vector)) {
            this.removeLayer(this._vector);
        }

        const speedInKmH = this._device.lastPosition.speed * KNOT_TO_KMH;

        if (speedInKmH < 5) {
            this._vector = null;
            return;
        }

        const distance = speedInKmH * SPEED_SCALE;
        const heading = position.course * Math.PI / 180 - Math.PI; // En radian
        const destLat = position.latitude + distance * Math.cos(heading);
        const destLng = position.longitude + distance * Math.sin(heading);

        this._vector = L.polyline(
            [this._marker?.getLatLng(), [destLat, destLng]],
            { color: 'red', weight: 3 }
        );

        this.addLayer(this._vector);
    },

    updatePosition: function (pos) {
        this._device.lastPosition = pos;
        this._marker.refresh(
            [
                this._device.lastPosition.latitude,
                this._device.lastPosition.longitude
            ],
            this._device
        );

        this._computeMotion();
    },

    updateDevice: function (dev) {
        dev.lastPosition = this._device.lastPosition;
        this._device = dev;

        this._marker.refresh(
            [
                this._device.lastPosition.latitude,
                this._device.lastPosition.longitude
            ],
            this._device
        );
        
        this._computeMotion();
    }
});


(() => {
    L.traccarPoint = (device) => new traccarPoint(device);
})();
